import React, { useState, useEffect } from "react";
import cloudIcon from "../../../../../assets/SVGs/Cloudy-clear at times 1.svg";
import careIcon from "../../../../../assets/SVGs/care.svg";
import alertIcon from "../../../../../assets/SVGs/alert.svg";
import uploadIcon from "../../../../../assets/SVGs/upload.svg";
import linkIcon from "../../../../../assets/SVGs/ci_external-link.svg";
import bankIcon from "../../../../../assets/SVGs/bank.svg";
import cautionIcon from "../../../../../assets/SVGs/Vector(4).svg";
import settingIcon from "../../../../../assets/SVGs/gearIcon.svg";
import FETCH from "../../../../../utils/fetch";
import moment from "moment";
import "../styles/disasterDashboard.css";
import { useHistory } from "react-router-dom";
import NewLoader from "../../../../../components/styled-components/loader/NewLoader";
import { setActiveStep } from "../../../../../redux/slices/loginSlice";
import { useDispatch } from "react-redux";
import { DisasterPortalModal } from "./DisasterPortalModal";
import { MODULE_API } from "../../../../../apis";
import { Icon } from "antd";
import swal from "sweetalert";

export const DisasterMainTiles = ({
  weatherData,
  weatherLocation,
  locationError,
  setCalanderData,
}) => {
  const dispatch = useDispatch();
  const history = useHistory();

  const [loading, setLoading] = useState(false);
  const [supplyData, setSupplyData] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalPages, setTotalPages] = useState(1);

  const [docData, setDocData] = useState([]);
  const [docPage, setDocPage] = useState(1);
  const [docTotalPages, setDocTotalPages] = useState(1);

  const [cloudData, setCloudData] = useState([]);
  const [cloudPage, setCloudPage] = useState(1);
  const [cloudTotalPages, setCloudTotalPages] = useState(1);

  const [insuranceData, setInsuranceData] = useState([]);
  const [insurancePage, setInsurancePage] = useState(1);
  const [insuranceTotalPages, setInsuranceTotalPages] = useState(1);

  const [bankData, setBankData] = useState([]);
  const [bankPage, setBankPage] = useState(1);
  const [bankTotalPages, setBankTotalPages] = useState(1);

  const [isModalOpen, setIsModalOpen] = useState(false);
  const [modulePortal, setModulePortal] = useState(null);
  const [formData, setFormData] = useState(null);

  const handleInputChnage = (name, value) => {
    setFormData({
      ...formData,
      [name]: value,
    });
  };
  const handleOpenModal = (name) => {
    setModulePortal(name);
    setIsModalOpen(true);
  };
  const handleOpenEditModal = (name, item) => {
    setModulePortal(name);
    setIsModalOpen(true);
    setFormData(item);
  };
  const handleCancelModal = () => {
    setIsModalOpen(false);
    setFormData(null);
    setModulePortal(null);
  };
  const handleSaveModal = async (moduleName) => {
    setIsModalOpen(false);
    if (formData && formData.id) {
      try {
        setLoading(true);
        let submitBody = {
          ...formData,
        };
        const data = await MODULE_API.updateClientModule(formData.id, {
          ...submitBody,
        });
        await getModuleListAfterSave(moduleName);
        if (data && data.status === 400) {
          swal("Error", data.message, "error");
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    } else {
      try {
        setLoading(true);
        let submitBody = {
          ...formData,
        };
        const data = await MODULE_API.addAsset(moduleName, {
          clientModules: [{ ...submitBody }],
        });
        await getModuleListAfterSave(moduleName);
        if (data && data.status === 400) {
          swal("Error", data.message, "error");
        }
        setLoading(false);
      } catch (error) {
        console.log(error);
        setLoading(false);
      }
    }
    setFormData(null);
    setModulePortal(null);
  };

  const deleteModule = async (id, recordToDelete) => {
    await swal({
      title: "Are you sure?",
      text: "You want to delete this?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (result) => {
      if (result === true) {
        setLoading(true);
        try {
          const res = await MODULE_API.removeClientModule({
            clientModules: [id],
          });
          await getModuleListAfterSave(recordToDelete.module);
        } catch (error) {
          setLoading(false);
        }
      }
    });
  };

  const getModuleListAfterSave = async (moduleName) => {
    switch (moduleName) {
      case "Cloud Storage":
        setCloudData([]);
        getModuleList({
          module: "Cloud Storage",
          pageNum: 1,
          setData: setCloudData,
          setPageNum: setCloudPage,
          setTotalPagesNum: setCloudTotalPages,
        });
        break;

      case "Insurance Portal":
        setInsuranceData([]);
        getModuleList({
          module: "Insurance Portal",
          pageNum: 1,
          setData: setInsuranceData,
          setPageNum: setInsurancePage,
          setTotalPagesNum: setInsuranceTotalPages,
        });
        break;

      case "Bank Portal":
        setBankData([]);
        getModuleList({
          module: "Bank Portal",
          pageNum: 1,
          setData: setBankData,
          setPageNum: setBankPage,
          setTotalPagesNum: setBankTotalPages,
        });
        break;

      default:
        console.warn(`Unhandled module name: ${moduleName}`);
    }
  };

  const getModuleList = async ({
    module,
    pageNum,
    setData,
    setPageNum,
    setTotalPagesNum,
  }) => {
    try {
      setLoading(true);
      const userRole =
      localStorage.getItem("role") != "undefined" &&
      JSON.parse(localStorage.getItem("role"));
    const ID = localStorage.getItem("accessId");
      const datares = await FETCH.post({
        url: "client-module-service/client-module/list",
         id: userRole === "Financial Advisor Client"
            ? `?module=${module}&page=${pageNum}&limit=10&clientId=${ID}`
            : `?module=${module}&page=${pageNum}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        setData((prev) => [...prev, ...datares.records]);
        if (module === "Important Document Storage") {
          setCalanderData((prev) => [...prev, ...datares.records]);
        }
        setTotalPagesNum(Math.ceil(datares.pagination.total / 10));
        setPageNum(pageNum);
      }
    } catch (error) {
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleScrollGeneric = (id, currentPage, totalPages, fetchFunc) => {
    const container = document.getElementById(id);
    if (!container) return;
    const { scrollTop, scrollHeight, clientHeight } = container;
    if (scrollTop + clientHeight >= scrollHeight) {
      if (currentPage < totalPages) {
        fetchFunc(currentPage + 1);
      }
    }
  };

  const getSupplyList = async (page) => {
    try {
      setLoading(true);
      const userRole =
      localStorage.getItem("role") != "undefined" &&
      JSON.parse(localStorage.getItem("role"));
    const ID = localStorage.getItem("accessId");
      let datares = await FETCH.post({
        url: "client-module-service/client-module/list",
        id: userRole === "Financial Advisor Client"
            ? `?module=Emergency Supplies Inventory&page=${page}&limit=10&clientId=${ID}`
            : `?module=Emergency Supplies Inventory&page=${page}&limit=10`,
        body: {},
      });
      if (datares && datares.records) {
        setSupplyData((prevItems) => [...prevItems, ...datares.records]);
        setCalanderData((prev) => [...prev, ...datares.records]);
        setTotalPages(
          Math.ceil(datares.pagination.total && datares.pagination.total / 10)
        );
        setCurrentPage(page);
      }
      setLoading(false);
    } catch (error) {
      console.log(error);
      setLoading(false);
    }
  };

  const handleScrollSupply = () => {
    const { scrollTop, scrollHeight, clientHeight } =
      document.getElementById("supplyDisplay");
    if (scrollTop + clientHeight >= scrollHeight) {
      if (currentPage < totalPages) {
        getSupplyList(currentPage + 1);
      }
    }
  };
  const getall = () => {
    getSupplyList(1);
    getModuleList({
      module: "Important Document Storage",
      pageNum: 1,
      setData: setDocData,
      setPageNum: setDocPage,
      setTotalPagesNum: setDocTotalPages,
    });
    getModuleList({
      module: "Cloud Storage",
      pageNum: 1,
      setData: setCloudData,
      setPageNum: setCloudPage,
      setTotalPagesNum: setCloudTotalPages,
    });
    getModuleList({
      module: "Insurance Portal",
      pageNum: 1,
      setData: setInsuranceData,
      setPageNum: setInsurancePage,
      setTotalPagesNum: setInsuranceTotalPages,
    });
    getModuleList({
      module: "Bank Portal",
      pageNum: 1,
      setData: setBankData,
      setPageNum: setBankPage,
      setTotalPagesNum: setBankTotalPages,
    });
  };
  useEffect(() => {
    getall();
  }, []);

  return (
    <div className="disaster-top-tiles" style={{ position: "relative" }}>
      <div style={{ width: "50%", marginTop: "1rem" }}>
        <div className="top-disaster-main-heading">Alerts and expirations</div>
        <div className="top-disaster-main-container-inner">
          <div className="top-disaster-main-card">
            <div className="disaster-top-card-heading-continer">
              {locationError ? (
                <div className="top-card-heading-img">{locationError}</div>
              ) : (
                <div className="weather-card-heading">
                  {" "}
                  {weatherLocation ? weatherLocation.name : ""}
                </div>
              )}
              <img src={settingIcon} alt="setting"></img>
            </div>
            <div className="weather-container" style={{ marginTop: "1rem" }}>
              <img
                src={
                  weatherData && weatherData.condition
                    ? weatherData.condition.icon
                    : cloudIcon
                }
                alt="cloudIcon"
              ></img>
              <div style={{ color: "#2a3da3" }}>
                <div>Today</div>
                {weatherData && (
                  <strong>
                    {weatherData.temp_c}°C / {weatherData.temp_f}°F
                  </strong>
                )}
                <div>
                  {weatherData && weatherData.condition
                    ? weatherData.condition.text
                    : ""}
                </div>
              </div>
            </div>
            <div
              className="disaster-top-card-heading-continer"
              style={{ marginTop: "1rem" }}
            >
              <div className="weather-card-heading"> Emergency Alerts:</div>
              <div>
                {" "}
                Learn More
                <img
                  src={linkIcon}
                  alt="setting"
                  style={{ cursor: "pointer" }}
                ></img>
              </div>
            </div>
          </div>
          <div className="top-disaster-main-card">
            <div className="disaster-top-card-heading-continer">
              <div className="top-card-heading-img">
                {" "}
                <img src={alertIcon} alt="cautionIcon"></img> Supply Expiration
                List
              </div>
              <img
                src={linkIcon}
                alt="setting"
                onClick={() => {
                  dispatch(setActiveStep(5));
                  history.push("/protector/disaster");
                }}
                style={{ cursor: "pointer" }}
              ></img>
            </div>
            <div>
              <div
                className="disaaster-DashboardListingRow"
                style={{
                  fontWeight: "bold",
                  borderBottom: "none",
                }}
              >
                <div className="checkListName" style={{ fontWeight: "bold" }}>
                  Supply
                </div>
                <div className="checkListName" style={{ fontWeight: "bold" }}>
                  Expiration
                </div>
              </div>
              <div
                id="supplyDisplay"
                style={{ height: "8rem", overflowY: "auto" }}
                onScroll={handleScrollSupply}
              >
                {supplyData &&
                  supplyData.length > 0 &&
                  supplyData.filter(item => item["Expiration Date"])
                  .map((item, index) => (
                    <div key={index} className="disaaster-DashboardListingRow">
                      <div className="checkListName">
                        {item.Item || item.module
                          ? item.Item || item.module
                          : "N/A"}
                      </div>
                      <div className="emailStatus">
                        {item["Expiration Date"]
                          ? moment(item["Expiration Date"]).format("MM/DD/YYYY")
                          : "N/A"}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
          <div className="top-disaster-main-card">
            <div className="disaster-top-card-heading-continer">
              <div className="top-card-heading-img">
                {" "}
                <img src={cautionIcon} alt="cautionIcon"></img> Document
                Expiration
              </div>
              <img
                src={linkIcon}
                alt="setting"
                onClick={() => {
                  dispatch(setActiveStep(4));
                  history.push("/protector/disaster");
                }}
                style={{ cursor: "pointer" }}
              ></img>
            </div>
            <div>
              <div
                className="disaaster-DashboardListingRow"
                style={{
                  fontWeight: "bold",
                  borderBottom: "none",
                }}
              >
                <div className="checkListName" style={{ fontWeight: "bold" }}>
                  Document
                </div>
                <div className="checkListName" style={{ fontWeight: "bold" }}>
                  Expiration
                </div>
              </div>
              <div
                id="docDisplay"
                onScroll={() =>
                  handleScrollGeneric(
                    "docDisplay",
                    docPage,
                    docTotalPages,
                    (nextPage) =>
                      getModuleList({
                        module: "Important Document Storage",
                        pageNum: nextPage,
                        setData: setDocData,
                        setPageNum: setDocPage,
                        setTotalPagesNum: setDocTotalPages,
                      })
                  )
                }
                style={{ height: "8rem", overflowY: "auto" }}
              >
                {docData &&
                  docData.length > 0 &&
                  docData.filter(item => item["Expiration Date"])
                  .map((item, index) => (
                    <div key={index} className="disaaster-DashboardListingRow">
                      <div className="checkListName">
                        {item.module ? item.module : "N/A"}
                      </div>
                      <div className="emailStatus">
                        {item["Expiration Date"]
                          ? moment(item["Expiration Date"]).format("MM/DD/YYYY")
                          : "N/A"}
                      </div>
                    </div>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div style={{ width: "50%", marginTop: "1rem" }}>
        <div className="top-disaster-main-heading">Portals & Services</div>
        <div className="top-disaster-main-container-inner">
          <div className="top-disaster-main-card">
            <div className="disaster-top-card-heading-continer">
              <div className="top-card-heading-img-portals">
                {" "}
                <img src={uploadIcon} alt="cautionIcon"></img> Cloud Storage
              </div>
              <img
                src={settingIcon}
                style={{ cursor: "pointer" }}
                alt="setting"
                onClick={() => {
                  handleOpenModal("Cloud Storage");
                }}
              ></img>
            </div>
            <div
              id="cloudDisplay"
              onScroll={() =>
                handleScrollGeneric(
                  "cloudDisplay",
                  cloudPage,
                  cloudTotalPages,
                  (nextPage) =>
                    getModuleList({
                      module: "Cloud Storage",
                      pageNum: nextPage,
                      setData: setCloudData,
                      setPageNum: setCloudPage,
                      setTotalPagesNum: setCloudTotalPages,
                    })
                )
              }
              style={{ height: "10.6rem", overflowY: "auto", marginTop: "8px" }}
            >
              {console.log("cloudData", cloudData)}
              {cloudData &&
                cloudData.length > 0 &&
                cloudData.map((item, index) => (
                  <div
                    key={index}
                    className="disaaster-DashboardListingRow"
                    style={{ border: "none", marginTop: "8px", padding: "4px" }}
                  >
                    <div className="checkListName" style={{ color: "#777699" }}>
                      {item.Name ? item.Name : "N/A"}
                    </div>
                    <div
                      className="emailStatus"
                      style={{
                        background: "transparent",
                        width: "fit-content",
                        display: "flex",
                        gap: "4px",
                      }}
                    >
                      <img
                        src={linkIcon}
                        alt="setting"
                        style={{
                          cursor: "pointer",
                          width: "18px",
                          height: "18px",
                        }}
                        onClick={() => {
                          const url = item["URL"] || "";
                          const validUrl =
                            url.startsWith("http://") ||
                            url.startsWith("https://")
                              ? url
                              : `https://${url}`;
                          window.open(validUrl, "_blank");
                        }}
                      ></img>
                      <Icon
                        type="edit"
                        style={{ color: "#2a3da3", fontSize: "16px" }}
                        color="#2a3da3"
                        onClick={() => {
                          handleOpenEditModal("Cloud Storage", item);
                        }}
                      />
                      <Icon
                        type="delete"
                        style={{ color: "red", fontSize: "16px" }}
                        onClick={() => deleteModule(item.id, item)}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="top-disaster-main-card">
            <div className="disaster-top-card-heading-continer">
              <div className="top-card-heading-img-portals">
                {" "}
                <img src={careIcon} alt="cautionIcon"></img> Insurance Portal
              </div>
              <img
                src={settingIcon}
                style={{ cursor: "pointer" }}
                alt="setting"
                onClick={() => {
                  handleOpenModal("Insurance Portal");
                }}
              ></img>
            </div>
            <div
              id="insuranceDisplay"
              onScroll={() =>
                handleScrollGeneric(
                  "insuranceDisplay",
                  insurancePage,
                  insuranceTotalPages,
                  (nextPage) =>
                    getModuleList({
                      module: "Insurance Portal",
                      pageNum: nextPage,
                      setData: setInsuranceData,
                      setPageNum: setInsurancePage,
                      setTotalPagesNum: setInsuranceTotalPages,
                    })
                )
              }
              style={{ height: "10.6rem", overflowY: "auto", marginTop: "8px" }}
            >
              {insuranceData &&
                insuranceData.length > 0 &&
                insuranceData.map((item, index) => (
                  <div
                    key={index}
                    className="disaaster-DashboardListingRow"
                    style={{ border: "none", marginTop: "8px", padding: "4px" }}
                  >
                    <div className="checkListName" style={{ color: "#777699" }}>
                      {item.Name ? item.Name : "N/A"}
                    </div>
                    <div
                      className="emailStatus"
                      style={{
                        background: "transparent",
                        width: "fit-content",
                        display: "flex",
                        gap: "4px",
                      }}
                    >
                      <img
                        src={linkIcon}
                        alt="setting"
                        style={{
                          cursor: "pointer",
                          width: "18px",
                          height: "18px",
                        }}
                        onClick={() => {
                          const url = item["URL"] || "";
                          const validUrl =
                            url.startsWith("http://") ||
                            url.startsWith("https://")
                              ? url
                              : `https://${url}`;
                          window.open(validUrl, "_blank");
                        }}
                      ></img>
                      <Icon
                        type="edit"
                        style={{ color: "#2a3da3", fontSize: "16px" }}
                        color="#2a3da3"
                        onClick={() => {
                          handleOpenEditModal("Insurance Portal", item);
                        }}
                      />
                      <Icon
                        type="delete"
                        style={{ color: "red", fontSize: "16px" }}
                        onClick={() => deleteModule(item.id, item)}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
          <div className="top-disaster-main-card">
            <div className="disaster-top-card-heading-continer">
              <div className="top-card-heading-img-portals">
                {" "}
                <img src={bankIcon} alt="cautionIcon"></img> Bank Portal
              </div>
              <img
                src={settingIcon}
                style={{ cursor: "pointer" }}
                alt="setting"
                onClick={() => {
                  handleOpenModal("Bank Portal");
                }}
              ></img>
            </div>
            <div
              id="bankDisplay"
              onScroll={() =>
                handleScrollGeneric(
                  "bankDisplay",
                  bankPage,
                  bankTotalPages,
                  (nextPage) =>
                    getModuleList({
                      module: "Bank Portal",
                      pageNum: nextPage,
                      setData: setBankData,
                      setPageNum: setBankPage,
                      setTotalPagesNum: setBankTotalPages,
                    })
                )
              }
              style={{ height: "10.6rem", overflowY: "auto", marginTop: "8px" }}
            >
              {bankData &&
                bankData.length > 0 &&
                bankData.map((item, index) => (
                  <div
                    key={index}
                    className="disaaster-DashboardListingRow"
                    style={{ border: "none", marginTop: "8px", padding: "4px" }}
                  >
                    <div className="checkListName" style={{ color: "#777699" }}>
                      {item.Name ? item.Name : "N/A"}
                    </div>
                    <div
                      className="emailStatus"
                      style={{
                        background: "transparent",
                        width: "fit-content",
                        display: "flex",
                        gap: "4px",
                      }}
                    >
                      <img
                        src={linkIcon}
                        alt="setting"
                        style={{
                          cursor: "pointer",
                          width: "18px",
                          height: "18px",
                        }}
                        onClick={() => {
                          const url = item["URL"] || "";
                          const validUrl =
                            url.startsWith("http://") ||
                            url.startsWith("https://")
                              ? url
                              : `https://${url}`;
                          window.open(validUrl, "_blank");
                        }}
                      ></img>
                      <Icon
                        type="edit"
                        style={{ color: "#2a3da3", fontSize: "16px" }}
                        color="#2a3da3"
                        onClick={() => {
                          handleOpenEditModal("Bank Portal", item);
                        }}
                      />
                      <Icon
                        type="delete"
                        style={{ color: "red", fontSize: "16px" }}
                        onClick={() => deleteModule(item.id, item)}
                      />
                    </div>
                  </div>
                ))}
            </div>
          </div>
        </div>
      </div>
      {isModalOpen && (
        <DisasterPortalModal
          module={modulePortal}
          handleSave={handleSaveModal}
          handleCancel={handleCancelModal}
          open={isModalOpen}
          handleChange={handleInputChnage}
          data={formData && formData}
        />
      )}
      <NewLoader isLoading={loading} />
    </div>
  );
};
